import * as React from 'react';
import { Button } from '@mui/material';
import { TextField } from '@mui/material';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import Divider from '@mui/material/Divider';
import { InputBase } from '@mui/material';
import Grid from '@mui/material/Grid';
import Modal from '@mui/material/Modal';
import { Checkbox } from '@mui/material';
import { FormGroup,FormControl,FormLabel } from '@mui/material';
import { InputLabel } from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';
import { sites,modals } from '../../Environment/Config';

type CaseSearchBoxType = {
    queryfunction:(param:any) => void
} 

export default function CaseSearchBox(props:CaseSearchBoxType){
    
    const [searchWord,setSearchWord] = React.useState('');
    const [open, setOpen] = React.useState(false);
    const [ID,setID] = React.useState('');
    const [tags,setTags] = React.useState('');
    const [filterSite, setFilterSite] = React.useState<string>('');
    const [filterModality, setFilterModality] = React.useState<string[]>([]);
    
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    /*
    const ChangeSite = (element:string, array:string[]) => {
        if (array.includes(element)) {
          const found = array.findIndex(item => item === element);
          array.splice(found, 1)
        } else {
          array.push(element)
        }
        setFilterSite(array)
        //props.getContentsData(array, 'site')
      }
    */
      const ChangeModality = (element:string, array:string[]) => {
        if (array.includes(element)) {
          const found = array.findIndex(item => item === element);
          array.splice(found, 1)
        } else {
          array.push(element)
        }
        setFilterModality(array)
        //props.getContentsData(array, 'modality')
      }
      
    const getQuery = () => {
        props.queryfunction({id:ID,keyword:searchWord,site:filterSite});
        setOpen(false);
    }
    
    const Modalstyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        maxWidth: 500,
        minWidth:300,
        display:'grid',
        alignContents: 'center',
        justifyItems:"center",
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
      };

    return(
        <React.Fragment>
            <Paper
                component="form"
                sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', minWidth:300,maxWidth: 500 }}
                >       
              <InputBase
                  sx={{ ml: 1, flex: 1 }}
                  placeholder="Search"
                  inputProps={{ 'aria-label': 'search' }}
                  value={searchWord}
                  onChange={(event) => {
                      setSearchWord(event.target.value);
                  }}
              />
              <IconButton type="button" sx={{ p: '10px' }} aria-label="search" onClick={()=>props.queryfunction({id:'',keyword:searchWord})}>
                  <SearchIcon />
              </IconButton>
              <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
              <div>
                  <IconButton sx={{ p: '10px' }} aria-label="menu" onClick={handleOpen}>
                      <MenuIcon />
                  </IconButton>
                  <Modal
                      open={open}
                      onClose={handleClose}
                      aria-labelledby="modal-modal-title"
                      aria-describedby="modal-modal-description"
                      >
                        <Box sx={Modalstyle}>
                            <FormControl fullWidth sx={{ mt: 0.5 }}>  
                                <TextField id="standard-basic" label="Key word" variant="standard" 
                                value={searchWord}
                                onChange={(event) => {
                                    setSearchWord(event.target.value);
                                }}/>
                            </FormControl>
                            <FormControl fullWidth sx={{ mt: 0.5 }}> 
                                <TextField id="standard-basic" label="ID" variant="standard" 
                                value={ID}
                                onChange={(event) => {
                                    setID(event.target.value);
                                }}/>
                            </FormControl>
                          <Grid sx={{display:'flex',gap:3,mt:2}}>
                              <Button variant="text" onClick={()=>setOpen(false)}>キャンセル</Button>
                              <Button variant="contained" onClick={getQuery}>検索</Button>
                          </Grid>
                      </Box>
                  </Modal>
              </div>       
          </Paper>
        </React.Fragment>
    )
}